import { render } from "./PassedModulesModal.vue?vue&type=template&id=4d53487e"
import script from "./PassedModulesModal.vue?vue&type=script&lang=js"
export * from "./PassedModulesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__